import { render, staticRenderFns } from "./ProductCategoriesList.vue?vue&type=template&id=74bc267c"
import script from "./ProductCategoriesList.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports